import { CompanyIntentResponseInterface, IntentTopicsDto } from '../dto';
import { CompanyIntentInterface } from '../models/company-intent.interface';

export function convertToIntentDataSource(intentScores: CompanyIntentResponseInterface, intents: IntentTopicsDto[]): CompanyIntentInterface[] {
  const result: CompanyIntentInterface[] = [];
  intentScores.search_results[0]?.intent.forEach(scoreItem => {
    const { intent_topic_id, intent_topic_score } = scoreItem;
    intents.forEach(intent => {
      intent.topics.forEach(topic => {
        if (topic.topic_id === intent_topic_id) {
          result.push({
            topic_name: topic.topic_name,
            category: intent.category,
            score: intent_topic_score
          });
        }
      });
    });
  });
  return result;
}
